import styled from '@emotion/styled';
import { getColor, getTextColorProps } from '../../common/UICommon';

export const SuggestedGuidesContentWrapper = styled.div`
  max-width: 330px;
  margin: auto;
  text-align: center;
`;
export const SuggestedGuidesLabel = styled.p`
  font-size: 14px;
  font-weight: 400;
  color: ${getColor('GRAY_50')};
  margin-bottom: 24px;
`;

export const SuggestedGuidesDescription = styled.p`
  font-size: 18px;
  font-weight: 400;
  ${getTextColorProps('PURPLE_GRADIENT')}
  margin-bottom: 32px;
`;

export const SuggestedGuidesList = styled.div`
  gap: 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;
